import React, { useRef, useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here
import withPasteUpload from "@rpldy/upload-paste";
import Uploady from "@rpldy/uploady";

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;
const CrossBtn = require("./../assets/img/cross-icon.svg").default;
const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;
const passwordIcon = require("./../assets/img/password-icon.svg").default;

const EditUser = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [selectedImages, setSelectedImages] = useState([]);

  const [userData, setUserData] = useState(null);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [customerDefault, setCustomerDefault] = useState("");
  const [errorMsg, setErrorMsg] = useState();
  const [draggingOver, setDraggingOver] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [avatarImage, setAvatarImage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    terms: "",
  });
  const [shipWithin, setShipWithin] = useState('');
  const [formSubmit2Loading, setFormSubmit2Loading] = useState(false);
  const [formSubmit2Error, setFormSubmit2Error] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleImageChange = (event) => {
    // const files = event.target.files;
    // const fileArray = Array.from(files);
    // setSelectedImages((prevSelectedImages) => [
    //   ...prevSelectedImages,
    //   ...fileArray,
    // ]);

    event.preventDefault();
    const files = event.target.files;
    const newImages = [...selectedImages];
    setAvatarImage(null);
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        console.log("normal file:", files[i]);
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    console.log("newImages: ", newImages);
    event.target.value = null;
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  // Edit user function
  const formSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    let finalFormDataCopy = { ...formData };
    if (selectedImages[0]) {
      finalFormDataCopy.avatar = selectedImages[0];
    } else {
      finalFormDataCopy.avatar = "";
    }
    const fd = new FormData();
    // Object.keys(finalFormDataCopy).map(item => fd.append(item, finalFormDataCopy[item]));
    fd.append("terms", finalFormDataCopy.terms);
    
    if (!finalFormDataCopy.terms) {
      setFormError("Terms is required.");
      setLoading(false);
      return;
    } else {
      setFormError("");
      console.log(finalFormDataCopy);
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      fetch(`https://cliqestimatebuilder.com/waiver_admin/users/update-terms`, {
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        method: "POST",
        body: fd,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.res == 1) {
            // setFormData({name: null, email: null, avatar: null});
            // navigate("/users");
            setFormError(data.msg);
          } else {
            setFormError(data.msg);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching file data:", error);
          setLoading(false);
        });
    }
  };


  const formSubmit2 = async (event) => {
    event.preventDefault();
    setFormSubmit2Loading(true);

    const fd = new FormData();
    fd.append("ship_within", shipWithin);

    if (!shipWithin) {
      setFormSubmit2Error("Ship Within is required.");
      setFormSubmit2Loading(false);
      return;
    }

    try {
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      const response = await fetch(
        `https://cliqestimatebuilder.com/waiver_admin/users/1`,
        {
          headers: {
            Authorization: `Bearer ${storedUserData.token}`,
          },
          method: "POST",
          body: fd,
        }
      );

      const data = await response.json();
      if (data.res === 1) {
        setFormSubmit2Error(data.msg);
      } else {
        setFormSubmit2Error(data.msg);
      }
    } catch (error) {
      console.error("Error submitting form 2:", error);
      setFormSubmit2Error("An error occurred.");
    }

    setFormSubmit2Loading(false);
  };

  const isImageFile = (file) => {
    // Define accepted image MIME types
    const acceptedImageTypes = ["image/jpeg", "image/png"];

    // Check if the file's MIME type is in the accepted types array
    return acceptedImageTypes.includes(file.type);
  };

  const PasteArea = withPasteUpload(({ onPasteUpload }) => {
    return (
      <div
        style={{
          width: "400px",
          height: "400px",
          border: "2px dashed #000", // Add a dashed border for visualization
          display: "none",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPaste={onPasteUpload}
      >
        Paste file here to upload
      </div>
    );
  });

  const onPasteUpload = useCallback((event) => {
    event.preventDefault(); // Prevent the default paste behavior
    const clipboardData = event.clipboardData || window.clipboardData;
    setAvatarImage(null);
    // const newImages = [];
    if (clipboardData && clipboardData.items) {
      const item = clipboardData.items[0];
      if (item.kind === "file") {
        const file = item.getAsFile();
        if (file && isImageFile(file)) {
          setSelectedImages([file]);
        } else {
          setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
          setTimeout(() => {
            setErrorMsg(null);
          }, 2000);
        }
      }
    }
    event.target.value = null;
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files[0];
    setAvatarImage(null);
    if (files && isImageFile(files)) {
      // You can now upload or process the pasted file
      setSelectedImages([files]);
      setErrorMsg(null);
    } else {
      setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
      setTimeout(() => {
        setErrorMsg(null);
      }, 2000);
    }
    setDraggingOver(false);
    setDragEnabled(false);
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragLeave = () => {
    setDraggingOver(false);
  };

  const fetchUserDetails = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/users/1`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.res == 1) {
          setFormData({
            terms: data.data.terms,
            ship: data.data.ship_within,
          });
          setShipWithin(data.data.ship_within);
        } else {
          //setFormError(data.msg);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  // useEffect(() => {
  //   const acceptableTag = document.querySelector(".imgBox");
  //   acceptableTag.addEventListener("paste", onPasteUpload);

  //   return () => {
  //     // Remove the paste event listener when the component unmounts
  //     acceptableTag.removeEventListener("paste", onPasteUpload);
  //   };
  // }, [onPasteUpload]);

  useEffect(() => {
    fetchUserDetails();
    return () => {
      setFormData({ terms: null });
      setFormError("");
    };
  }, []);

  const handleShipWithinChange = (e) => {
    setShipWithin(e.target.value);
  };

  

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          
            <div className="viewOne">
              <div className="viewOneLeft">
                <h2>Edit Terms & Conditions</h2>
              </div>
              <div className="viewOneRight"></div>
            </div>

            <div className="viewBox ">
            <form onSubmit={formSubmit}>
              <ul className="previewOne crteForm udtUl">
                <li>
                  <div className="inCkeck">
                    <>
                      <label>Terms:</label>
                    </>
                  </div>
                  <span className="editTerms">
                    <textarea
                      name="terms"
                      value={formData.terms}
                      onChange={handleChange}
                    ></textarea>
                  </span>
                </li>

                <li>
                  {loading ? (
                    <button type="submit" disabled className="userFormBtn">
                      Please wait...
                    </button>
                  ) : (
                    <button type="submit" className="userFormBtn">
                      Save
                    </button>
                  )}
                </li>
                <li>
                  {formError ? (
                    <span className="lgnStatus">{formError}</span>
                  ) : null}
                </li>
              </ul>
            </form>

            <form onSubmit={formSubmit2}>
            <ul className="previewOne crteForm udtUl frmShip">
                <li>
                  <div className="inCkeck">
                    <>
                      <label>Ship Within:</label>
                    </>
                  </div>
                  <span className="editTerms">
                    <input
                      type="text"
                      value={shipWithin}
                      onChange={(e) => setShipWithin(e.target.value)}
                    />
                  </span>
                </li>
                <li>
                  {formSubmit2Loading ? (
                    <button type="submit" disabled className="userFormBtn">
                      Please wait...
                    </button>
                  ) : (
                    <button type="submit" className="userFormBtn">
                      Save
                    </button>
                  )}
                </li>
                <li>
                  {formSubmit2Error ? (
                    <span className="lgnStatus">{formSubmit2Error}</span>
                  ) : null}
                </li>
              </ul>

            </form>
              

            </div>
          
          
        </div>
      </div>
    </div>
  );
};

export default EditUser;
